module.exports = __webpack_public_path__ + "media/08.5b87bf0d.mp3";